// ** React Imports
import { Navigate, Outlet, useLocation } from "react-router-dom"

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "@layouts/VerticalLayout"

// ** Menu Items Array
import Menu from "@src/navigation/vertical"

// ** Hooks
import useTwoFactorStatus from "@src/hooks/user/useTwoFactorStatus"

// ** Spinner
import Spinner from "@src/@core/components/spinner/Fallback-spinner"

// ** Puerta de entrada a todo lo privado.
//
// Este layout es el padre de todas las rutas con sesión, así que las dos condiciones para
// entrar viven aquí y no repetidas en cada ruta —donde además faltaban en algunas—. Se
// comprueban al renderizar, no al cargar el módulo, de modo que una sesión o un 2FA activados
// hace un instante ya cuentan.

// Única pantalla accesible sin la verificación en dos pasos, porque es donde se activa.
// Bloquear también esta dejaría a la persona sin ninguna forma de cumplir lo que se le pide.
const TWO_FACTOR_SETUP = "/profile"

const VerticalLayout = (props) => {
  const { menuItems } = Menu()
  const { enabled: hasTwoFactor, isLoading: checkingTwoFactor } = useTwoFactorStatus()
  const { pathname } = useLocation()

  // Se mira localStorage y no el contexto de usuario a propósito: es lo mismo que mira el
  // Router para decidir si /login se enseña o se esquiva, y si los dos no miraran lo mismo
  // volverían a mandarse la pantalla el uno al otro.
  if (!localStorage.getItem("userInfo")) {
    return <Navigate replace to="/login" />
  }

  // Mientras la ficha viaja no se decide. Con un `return null` la pantalla queda en blanco y
  // vuelve a parecer rota, que es justo lo que este bloqueo tiene que dejar de hacer.
  if (checkingTwoFactor) {
    return <Spinner />
  }

  // Sin 2FA no se entra a ninguna parte, ni siquiera a Inicio. El menú ya venía vacío en ese
  // caso, pero un menú vacío no impedía llegar escribiendo la dirección, y sobre todo no
  // explicaba nada: se leía como una aplicación rota. Ahora lleva al único sitio donde se
  // puede resolver, y allí se dice por qué (views/user/account-settings).
  if (!hasTwoFactor && pathname !== TWO_FACTOR_SETUP) {
    return <Navigate replace to={TWO_FACTOR_SETUP} />
  }

  return (
    <Layout menuData={menuItems} {...props}>
      <Outlet />
    </Layout>
  )
}

export default VerticalLayout
